import {PlanAnalytics} from "@/report/PlanAnalytics"

export interface PCReport {
  id: string
  platformId: string
  platformName: string
  planId: string | null
  planName: string | null
  companyId: string | null
  companyName: string | null
  templateName: string

  meetingLocation: string | null
  meetingDate: Date | null
  reportingStartDate: Date
  reportingEndDate: Date

  reportPages: Array<ReportPage>

  contacts: Contacts
  contactsTableImageId: string
  repsTableImageId: string

  encodedProviderLogo: string

  planAnalytics: PlanAnalytics
}

export interface ReportPage {
  id: string | null
  templatePageNumber: number
  templatePageName: string | null
  sequence: number
  heading: string | null
  sourceFilename: string | null
  sourcePageNumber: number | null

  pageSections: Array<PageSection>
  pageResources: Array<PageResource>
}

export interface PageSection {
  id: string | null
  templateSectionName: string | null
  sequence: number
  heading: string | null
  sectionItems: Array<SectionItem>
}

export interface PageResource {
  id: string | null
  type: string
  name: string
  heading: string | null
}

export interface SectionItem {
  id: string | null
  sequence: number
  text: string | null
  note: string | null
}

export interface Contacts {
  employerContact: Contact
  planContact: Contact
  providerContacts: Array<Contact>
  employerReps: Array<string>
  memberReps: Array<string>
  cover: Cover
}

export interface Contact {
  title: string
  description: string
  name: string
  address: string
  phone: string
  email: string
}

export interface Cover {
  providerName: string
  providerAbn: string
  platformName: string
  platformShortName: string
  planName: string
  planShortName: string
  trusteeName: string
  trusteeAbn: string
  trusteeAfsl: string
}

export interface PdfResource {
  platformId: string | null
  platformName: string | null
  filename: string
  modified: Date
  pages: number
  size: number
}

export const PDF_SOURCE_PAGE = "PdfSourcePage"
